import { NotificationManager } from 'react-notifications';

export default function msgNotificacion(message, icono, time = 5000) {
  switch (icono) {
    case 'info':
      return (
        NotificationManager.info(message, 'Información', time)
      )
    case 'success':
      return (
        NotificationManager.success(message, 'Éxito', time)
      )
    case 'warning':
      return (
        NotificationManager.warning(message, 'Alerta de aplicación', time)      
      )
    case 'error':
      return (        
        NotificationManager.error(message, 'Error de aplicación', time, () => {
          alert('callback');
        })
      )      
    default:
      break;
  }
}